import { render, staticRenderFns } from "./InterventionTable.vue?vue&type=template&id=2203dc88"
import script from "./InterventionTable.vue?vue&type=script&lang=js"
export * from "./InterventionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports